<div class="info-payment">
    <div class="dialog-title-row">
        <p class="title-info-payment m-0">Pedido: <span>{{num_ticket ? num_ticket : idOrder}}</span></p>
        <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
    </div>
    <!-- <mat-divider></mat-divider> -->
    <div class="div-info-transaction">
        <div class="title-info-transaction">
            Canal:
        </div>
        <div class="text-info-transaction">
            {{channel}}
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="div-info-transaction" *ngIf="order.id_invoicing">
        <div class="title-info-transaction">
            ID de transacción:
        </div>
        <div class="text-info-transaction">
            {{order.id_invoicing}}
        </div>
    </div>
    <mat-divider *ngIf="order.id_invoicing"></mat-divider>
    <div class="div-info-transaction">
        <div class="title-info-transaction">
            Estado:
        </div>
        <div class="text-info-transaction">
            {{order.status.name}}
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="div-info-transaction">
        <div class="title-info-transaction">
            Fecha:
        </div>
        <div class="text-info-transaction">
            {{order.created_at | date:'dd/MM/y HH:mm':'+0000'}}
        </div>
    </div>
    <div *ngIf="order.payment">
        <!-- <mat-divider></mat-divider> -->
        <div class="title-payment">
            Información de pago:
        </div>
        <!-- <mat-divider></mat-divider> -->
        <div class="div-info-transaction">
            <div class="title-info-transaction">
                Estado:
            </div>
            <div class="text-info-transaction">
                {{order.status.name}}
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="div-info-transaction">
            <div class="title-info-transaction">
                Fecha confirmación:
            </div>
            <div class="text-info-transaction">
                {{order.updated_at | date:'dd/MM/y HH:mm':'+0000'}}
            </div>
        </div>
        <mat-divider></mat-divider>
        <div class="div-info-transaction">
            <div class="title-info-transaction">
                Tarjeta:
            </div>
            <div class="text-info-transaction">
                {{order.payment?.detail_order[0].tarjeta }} *{{order.payment.detail_order[0].last_digits }}
            </div>
        </div>
        <div *ngIf="order.payment.detail_order[0].bank">
            <mat-divider></mat-divider>
            <div class="div-info-transaction">
                <div class="title-info-transaction">
                    Banco:
                </div>
                <div class="text-info-transaction">
                    {{order.payment?.detail_order[0].bank }}
                </div>
            </div>
        </div>

        <div *ngIf="isAdmin">
            <mat-divider></mat-divider>
            <div class="div-info-transaction">
                <div class="title-info-transaction">
                    IP:
                </div>
                <div class="text-info-transaction">
                    {{order.payment?.ip}}
                </div>
            </div>
            <!-- <mat-divider></mat-divider> -->
        </div>
    </div>
</div>